/** Collapsible all-lengths list, each row a stroke-coloured dot + ordinal + type + duration. */
import { signal } from '@preact/signals'
import { store } from '../state/store'
import { formatDuration } from '../analytics/format'
import { strokeColor, strokeLabel, REST_COLOR, SELECTED_COLOR } from './uiState'

const open = signal(false)

export function LengthsTable() {
  const activity = store.activity.value
  const sel = store.selection.value
  if (!activity) return null

  return (
    <div class="card rows" style="overflow:hidden">
      <div class="disclosure" onClick={() => (open.value = !open.value)}>
        <svg
          width="12"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
          class={`chev${open.value ? ' open' : ''}`}
        >
          <path
            d="M1 1l5 5-5 5"
            stroke="#8e8e93"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="card-title">All lengths</div>
        <div class="muted" style="font-size:12px">
          {activity.lengths.length} rows
        </div>
        <div style="flex:1" />
        <div class="muted" style="font-size:12px">
          {open.value ? 'Hide' : 'Expand'}
        </div>
      </div>
      {open.value && (
        <div class="scroll-y">
          {activity.lengths.map((l) => {
            const selected = sel.has(l.ordinal)
            const dot = selected
              ? SELECTED_COLOR
              : l.active
                ? strokeColor(l.swimStroke)
                : REST_COLOR
            return (
              <div
                key={l.ordinal}
                class={`row clickable${selected ? ' selected' : ''}`}
                onClick={(e) =>
                  store.select(l.ordinal, { shift: e.shiftKey, toggle: !e.shiftKey })
                }
              >
                <span class="dot" style={`background:${dot}`} />
                <div style="width:34px; font-weight:600">{l.ordinal}</div>
                <div style="width:96px" class={l.active ? '' : 'muted'}>
                  {l.active ? strokeLabel(l.swimStroke) : 'rest'}
                </div>
                <div style="width:60px">{formatDuration(l.durationMs)}</div>
                <div style="flex:1" class="muted">
                  {l.active ? `${l.strokes} strokes` : '—'}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
